module.exports = __webpack_public_path__ + "img/try.0054ae4b.png";